/**
 * 语言配置-俄语
 */
export const ru_Language = {

}



// WEBPACK FOOTER //
// ./src/language/package/ru.js